export default {"src":"/_next/static/media/arrow-left-single.bb2c3ab1.svg","height":18,"width":11};